import React from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import SideBarLayout from "../../../layout/side-bar-layout"
import { TITLE_DESIGN_SYSTEM_PAGE } from "../../../../utils/constants"
import CodeViewer from "../../../components/CodeViewer/code-viewer"
import SummarySection from "src/v2/components/SummarySection/summary-section"

const SummarySectionDesignSystemPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Summary Section`

    const fields = [
        {
            label: "DATA REFERÊNCIA",
            value: "10/01/2026",
        },
        {
            label: "FONTE",
            value: "Exemplo",
        },
        {
            label: "RATING",
            value: "AAA",
        },
    ]

    const longFields = [
        {
            label: "DATA REFERÊNCIA",
            value: "10/01/2026",
            gridProps: { xxxs: 4, sm: 2, lg: 2 },
        },
        {
            label: "FATO",
            value: "Descrição de exemplo para demonstrar uma seção com texto mais longo.",
            gridProps: { xxxs: 4, sm: 10, lg: 10 },
        },
    ]

    const codeUsage = `import SummarySection from "src/v2/components/SummarySection/summary-section"

const fields = [
    {
        label: "DATA REFERÊNCIA",
        value: "10/01/2026",
    },
    {
        label: "FONTE",
        value: "Exemplo",
    },
    {
        label: "RATING",
        value: "AAA",
    },
]

// Com dados
<SummarySection
    title="Último Rating Emissão"
    fields={fields}
    onClick={() => console.log("Mostrar todos")}
/>

// Estado vazio
<SummarySection
    title="Garantias"
    empty
    emptyText="Não há garantias para o CETIP consultado"
    fields={[]}
/>

// Com gridProps por campo
<SummarySection
    title="Último Fato Relevante"
    fields={[
        {
            label: "DATA REFERÊNCIA",
            value: "10/01/2026",
            gridProps: { xxxs: 4, sm: 2, lg: 2 },
        },
        {
            label: "FATO",
            value: "Descrição do fato relevante.",
            gridProps: { xxxs: 4, sm: 10, lg: 10 },
        },
    ]}
/>`

    const codeProps = `type SummarySectionProps = {
  title: string,       // Título da seção
  fields?: SummaryField[], // Campos exibidos na seção
  empty?: boolean,    // Quando true, exibe emptyText no lugar dos campos
  emptyText?: string, // Mensagem exibida no estado vazio
  onClick?: () => void, // Ação do botão "MOSTRAR TODOS"
  fieldGridProps?: object // Grid padrão aplicado aos campos
}

type SummaryField = {
  label: string,
  value?: string | number | ReactNode,
  gridProps?: object
}`

    return (
        <SideBarLayout header title={TITLE_PAGE} headerTitle={TITLE_PAGE}>
            <Box sx={{ mt: -2 }}>
                <Stack spacing={3}>
                    <Paper>
                        <Box p={3}>
                            <Typography
                                variant="h4"
                                gutterBottom
                                color="common.white"
                            >
                                SummarySection
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Componente utilizado para exibir uma seção de
                                resumo com título, campos, estado vazio e botão
                                “MOSTRAR TODOS”. Pode ser reutilizado em telas
                                que precisem apresentar blocos de informações
                                resumidas.
                            </Typography>

                            <Stack spacing={4} mt={4}>
                                <SummarySection
                                    title="Último Rating Emissão"
                                    fields={fields}
                                    onClick={() => {}}
                                />

                                <SummarySection
                                    title="Garantias"
                                    empty
                                    emptyText="Não há garantias para o CETIP consultado"
                                    fields={[]}
                                />

                                <SummarySection
                                    title="Último Fato Relevante"
                                    fields={longFields}
                                    onClick={() => {}}
                                />
                            </Stack>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography
                                variant="h6"
                                gutterBottom
                                color="common.white"
                            >
                                Uso básico
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                paragraph
                            >
                                Utilize o componente para montar blocos de
                                resumo com campos simples e ação de visualização
                                completa.
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer
                                        code={codeUsage}
                                        language="jsx"
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography
                                variant="h6"
                                gutterBottom
                                color="common.white"
                            >
                                Propriedades principais
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                paragraph
                            >
                                Interface do componente.
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer
                                        code={codeProps}
                                        language="tsx"
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>
                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default SummarySectionDesignSystemPage